"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get cleanCommandPaletteCache () {
        return cleanCommandPaletteCache;
    },
    get cleanCommandPaletteCacheForUser () {
        return cleanCommandPaletteCacheForUser;
    },
    get getCommandPaletteForUserWorkspace () {
        return getCommandPaletteForUserWorkspace;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getCommandPaletteForUserWorkspace(userId, workspaceId = 'nc', ncMeta = _Noco.default.ncMeta) {
    var _cmdData_data;
    const key = `${_globals.CacheScope.CMD_PALETTE}:${userId}:${workspaceId}`;
    let cmdData = await _NocoCache.default.get('root', key, _globals.CacheGetType.TYPE_OBJECT);
    if (!cmdData) {
        cmdData = {
            data: await ncMeta.knexConnection(`${_globals.MetaTable.PROJECT} as b`).select('b.id as base_id', 'b.title as base_title', 'b.meta as base_meta', 'b.order as base_order', 'bu.roles as base_role', 't.id as table_id', 't.title as table_title', 't.type as table_type', 't.meta as table_meta', 't.order as table_order', 'v.id as view_id', 'v.title as view_title', 'v.type as view_type', 'v.meta as view_meta', 'v.order as view_order', 'dm.disabled').innerJoin(`${_globals.MetaTable.PROJECT_USERS} as bu`, `b.id`, `bu.base_id`).innerJoin(`${_globals.MetaTable.MODELS} as t`, `t.base_id`, `b.id`).innerJoin(`${_globals.MetaTable.VIEWS} as v`, `v.fk_model_id`, `t.id`).leftJoin(`${_globals.MetaTable.MODEL_ROLE_VISIBILITY} as dm`, function() {
                this.on(`dm.fk_view_id`, `=`, `v.id`).andOn(`dm.role`, `=`, `bu.roles`);
            }).where('bu.fk_user_id', userId).andWhereNot('bu.roles', _nocodbsdk.ProjectRoles.NO_ACCESS).andWhere('t.mm', false).andWhere(function() {
                this.where('dm.disabled', false).orWhereNull('dm.disabled');
            }).andWhere(function() {
                this.where('b.deleted', false).orWhereNull('b.deleted');
            }).andWhere(function() {
                this.where('t.deleted', false).orWhereNull('t.deleted');
            })
        };
        await _NocoCache.default.set('root', key, cmdData);
        // append to lists for later cleanup
        await _NocoCache.default.set('root', `${_globals.CacheScope.CMD_PALETTE}:ws`, [
            key
        ]);
        await _NocoCache.default.set('root', `${_globals.CacheScope.CMD_PALETTE}:user:${userId}`, [
            key
        ]);
    }
    return cmdData == null ? void 0 : (_cmdData_data = cmdData.data) == null ? void 0 : _cmdData_data.sort((a, b)=>{
        if (a.base_order !== b.base_order) {
            var _a_base_order, _b_base_order;
            return ((_a_base_order = a.base_order) != null ? _a_base_order : Infinity) - ((_b_base_order = b.base_order) != null ? _b_base_order : Infinity);
        }
        if (a.table_order !== b.table_order) {
            var _a_table_order, _b_table_order;
            return ((_a_table_order = a.table_order) != null ? _a_table_order : Infinity) - ((_b_table_order = b.table_order) != null ? _b_table_order : Infinity);
        }
        if (a.view_order !== b.view_order) {
            var _a_view_order, _b_view_order;
            return ((_a_view_order = a.view_order) != null ? _a_view_order : Infinity) - ((_b_view_order = b.view_order) != null ? _b_view_order : Infinity);
        }
        return 0;
    });
}
async function cleanCommandPaletteCache(_ws) {
    const keys = await _NocoCache.default.get('root', `${_globals.CacheScope.CMD_PALETTE}:ws`, _globals.CacheGetType.TYPE_ARRAY);
    if (keys) {
        await _NocoCache.default.del('root', [
            ...keys,
            `${_globals.CacheScope.CMD_PALETTE}`
        ]);
    }
}
async function cleanCommandPaletteCacheForUser(userId) {
    const keys = await _NocoCache.default.get('root', `${_globals.CacheScope.CMD_PALETTE}:user:${userId}`, _globals.CacheGetType.TYPE_ARRAY);
    if (keys) {
        await _NocoCache.default.del('root', [
            ...keys,
            `${_globals.CacheScope.CMD_PALETTE}:${userId}`
        ]);
    }
}
